import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../state/AuthProvider";
import { PrototypeBanner } from "./ui";

export function ProtectedRoute({
  allowedRoles,
  redirectTo = "/signin",
}: {
  allowedRoles?: Array<"admin" | "staff" | "parent" | "student">;
  redirectTo?: string;
}) {
  const { account, session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="app">
        <PrototypeBanner />
        <main className="shell">
          <p className="anno">Loading...</p>
        </main>
      </div>
    );
  }

  if (!session || !account) {
    const returnPath = location.pathname + location.search;
    const separator = redirectTo.includes("?") ? "&" : "?";
    const target = `${redirectTo}${separator}next=${encodeURIComponent(returnPath)}`;
    return <Navigate to={target} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(account.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
